import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: 'calc(100% - 72px)',
    minHeight: 'calc(100svh - 80px)',
    [theme.breakpoints.down(450)]: {
      width: 'calc(100% - 72px + 1.5rem)',
      marginTop: '1rem'
    }
  },

  crumbs: {
    marginTop: '12px'
  },

  titleBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '20px 0 24px 0',
    width: '100%',
    height: '30px',

    [theme.breakpoints.down(1310)]: {
      alignItems: 'flex-start',
      flexDirection: 'column',
      height: 'unset'
    }
  },

  titleSection: {
    display: 'flex',
    alignItems: 'center',

    [theme.breakpoints.down(414)]: {
      flexWrap: 'wrap'
    }
  },

  title: {
    fontSize: theme.size.lg,
    color: '#1F1F1F'
  },

  statusBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: '16px',
    marginRight: '16px',
    borderRadius: '4px',
    height: '28px',
    fontSize: theme.size.sm
  },

  published: {
    width: '102px',
    background: theme.palette.secondary.main,

    color: theme.palette.primary.main
  },

  draft: {
    width: '76px',
    background: '#C6C6C6',
    color: '#4A4A4A'
  },

  mobileOptions: {
    display: 'none',

    [theme.breakpoints.down(414)]: {
      display: 'block'
    }
  },

  buttonArea: {
    display: 'flex',
    alignItems: 'center',

    [theme.breakpoints.down(1310)]: {
      marginTop: '0.5rem'
    },

    [theme.breakpoints.down(414)]: {
      display: 'none'
    }
  },

  editButton: {
    marginRight: '16px',
    width: 'auto'
  },

  editIcon: {
    marginRight: '4px'
  },

  publish: {
    marginRight: '10px'
  },

  menu: {
    cursor: 'pointer'
  },

  menuTitleContainer: {
    display: 'flex',
    flexFlow: 'column',
    gap: 2,
    cursor: 'default'
  },

  menuTitle: {
    height: 'unset',
    padding: '0px 0px 4px 8px'
  }
}))

export default useStyles
